@if (shell.muestraInterruptor) {
  <div class="suite-switch" [class.suite-switch--header]="ubicacion === 'header'">
    <button type="button" class="suite-switch__btn" (click)="alternar()">
      {{ etiqueta }}
    </button>
  </div>
}
